module.exports = __webpack_public_path__ + "static/media/wave-3.2eeb0012.svg";